(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_contact-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sme-contact-form')) {
    customElements.define('sme-contact-form', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        if (this.querySelector('[data-contact-result]')) return;
        const intent = new URLSearchParams(window.location.search).get('objet');
        if (intent?.toLowerCase() !== 'devis') return;
        for (const select of this.querySelectorAll('select')) {
          const quote = Array.from(select.options).find(option => option.value.toLowerCase() === 'devis');
          if (quote) select.value = quote.value;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_dropdown-filter"] && !Shopify.designMode) return;
  try {
    class DropdownFilterBlock extends HTMLElement {
    constructor() {
      super();

      this.menu = [];
      this.selects = [];
      this.submitButton = null;
    }

    connectedCallback() {
      const dataScript = this.querySelector("[data-dropdown-filter-data]");
      this.selects = Array.from(
        this.querySelectorAll("[data-dropdown-filter-select]"),
      );
      this.submitButton = this.querySelector("[data-dropdown-filter-submit]");

      if (!dataScript || !this.selects.length || !this.submitButton) return;

      try {
        this.menu = JSON.parse(dataScript.textContent);
      } catch (error) {
        this.menu = [];
      }

      this.populateSelect(this.selects[0], this.menu);
      this.selects.forEach((select) => {
        select.addEventListener("change", this.onSelectChange.bind(this));
      });
      this.submitButton.addEventListener("click", this.onSubmit.bind(this));
      this.updateSubmitState();
    }

    onSelectChange(event) {
      const level = Number(event.target.dataset.level);
      const selectedItem = this.getSelectedItem(level);

      this.clearSelectsAfter(level);

      const nextSelect = this.selects[level + 1];
      if (nextSelect && selectedItem?.children?.length) {
        this.populateSelect(nextSelect, selectedItem.children);
        nextSelect.disabled = false;
      }

      this.updateSubmitState();
    }

    populateSelect(select, items) {
      const placeholder = select.options[0]?.textContent || "";
      select.innerHTML = "";
      select.append(new Option(placeholder, ""));

      items.forEach((item, index) => {
        const option = new Option(item.title, String(index));
        option.dataset.url = item.url || "";
        select.append(option);
      });
    }

    clearSelectsAfter(level) {
      this.selects.slice(level + 1).forEach((select) => {
        const placeholder = select.options[0]?.textContent || "";
        select.innerHTML = "";
        select.append(new Option(placeholder, ""));
        select.disabled = true;
      });
    }

    getSelectedItem(level) {
      let items = this.menu;
      let selectedItem = null;

      for (let index = 0; index <= level; index += 1) {
        const select = this.selects[index];
        if (!select || select.value === "") return selectedItem;

        selectedItem = items[Number(select.value)];
        items = selectedItem?.children || [];
      }

      return selectedItem;
    }

    getTargetItem() {
      let selectedItem = null;

      this.selects.forEach((select, index) => {
        if (select.value !== "") {
          selectedItem = this.getSelectedItem(index);
        }
      });

      return selectedItem;
    }

    updateSubmitState() {
      const selectedItem = this.getTargetItem();
      this.submitButton.disabled = !selectedItem?.url;
    }

    normalizeUrl(url) {
      const trimmedUrl = url.trim();
      if (!trimmedUrl || trimmedUrl.startsWith("#")) return "";

      if (
        trimmedUrl.startsWith("/") ||
        /^[a-z][a-z0-9+.-]*:/i.test(trimmedUrl)
      ) {
        return trimmedUrl;
      }

      return `/${trimmedUrl}`;
    }

    onSubmit() {
      const selectedItem = this.getTargetItem();
      const targetUrl = this.normalizeUrl(selectedItem?.url || "");
      if (!targetUrl) return;

      if (this.submitButton.hasAttribute("data-open-in-new-tab")) {
        window.open(targetUrl, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = targetUrl;
      }
    }
  }

  if (!customElements.get("dropdown-filter-block")) {
    customElements.define("dropdown-filter-block", DropdownFilterBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
